import { gql } from '@apollo/client';

const CREATE_UPDATE_SUPPLIERORDER_STATUS = gql`mutation createUpdateSupplierOrderStatus($input: SupplierOrderStatusInput!) {
	incomingOrders {
		createUpdateSupplierOrderStatus(input: $input) {
			success
			result {
				action
				color
				id
				name
				productionStatus
			}
		}
	}
}`;

export default CREATE_UPDATE_SUPPLIERORDER_STATUS;
